import { CORTES } from '../actions/types';

const initialState = {
    listado: [],
    informacion: null
};

export default (state = initialState, action) => {
    const { type, payload } = action;

    switch (type) {
        case CORTES.BUSCAR:
            return { ...state, listado: payload };

        case CORTES.INFORMACION:
            return { ...state, informacion: payload };

        case CORTES.LIMPIAR:
            return { ...state, informacion: null };

        default:
            return state;
    }
};
